module.exports = __webpack_public_path__ + "static/media/default-azure-identity.4f0e6933.md";